import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { CampanhaStatusBadgeComponent } from './badge';
import { CampanhaStatusSelectComponent } from './select';
import { CampanhaStatusMultiselectComponent } from './multiselect';
import { CampanhaStatusPipe, CampanhaStatusIconPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        CampanhaStatusSelectComponent,
        CampanhaStatusMultiselectComponent,
        CampanhaStatusBadgeComponent,

        // Pipes
        CampanhaStatusPipe,
        CampanhaStatusIconPipe
    ],
    exports: [
        CampanhaStatusSelectComponent,
        CampanhaStatusMultiselectComponent,
        CampanhaStatusBadgeComponent,

        // Pipes
        CampanhaStatusPipe,
        CampanhaStatusIconPipe
    ],
    providers: [
        // Pipes
        CampanhaStatusPipe,
        CampanhaStatusIconPipe
    ]
})
export class CampanhaStatusModule { }
